<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px")
    v-card
      v-card-title.pa-4
        div.h6.basic800--text {{ $t('edit_page_name') }}
      v-card-text.px-4.py-0
        div.s1.primary--text {{ $t('page_name') }}
        div.p2.basic700--text.mt-1 {{ $t('your_customer_wont_see') }}
        v-form(ref="form")
          v-text-field.mt-2(v-model='form.name' background-color="basic200" height="40" outlined dense persistent-hint counter :maxlength="100" placeholder="Write form name here" :rules="rules.not_empty")
      v-card-actions
        v-spacer
        v-btn(color='white', text @click="showModal = false")
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2.button-AA-small(color='info500' depressed height=32 @click="clickSave" :loading="isLoading" dark) {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'
import LandingFormType from '@/components/landingform/LandingFormType.vue'

export default {
  name: 'EditLandingPageName',
  props: ['open', 'parentForm'],
  components: { LandingFormType },
  data: () => ({
    isLoading: false,
    form: {},
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    },
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.form = JSON.parse(JSON.stringify(this.parentForm))
  },
  methods: {
    ...mapActions(['showMessage']),
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let data = {
        name: this.form.name
      }
      this.$axios.patch(`/forms/${this.parentForm.id}`, data)
        .then(resp => {
          this.$emit('update:parentForm', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "edit_page_name": "Edit page name",
    "page_name": "Page name",
    "your_customer_wont_see": "Your customers won’t see this."
  },
  "id": {
    "edit_page_name": "Edit nama judul",
    "page_name": "judul",
    "your_customer_wont_see": "Tidak akan kelihatan untuk pelanggan"
  }
}
</i18n>